import { Tooltip } from '@app/components/various/Tooltip';
import { composeFullProductName } from '@app/logic/invoices';
import { useIsOverflowing } from '@app/utils/hooks/useIsOverflowing';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { Invoice } from '@typings';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  invoiceItem: Invoice.InvoiceItem;
}

export const ProductNameCell = ({ invoiceItem }: Props) => {
  const { t } = useTranslation(['common']);

  const nameRef = React.useRef<HTMLDivElement>(null);
  const isOverflowing = useIsOverflowing(nameRef, { widthOnly: true });

  const productName = composeFullProductName(invoiceItem);
  const hasArtNo = isDefined(invoiceItem.SKU) && !isEmpty(invoiceItem.SKU);

  return (
    <Tooltip
      content={
        isOverflowing && (
          <div className="body-5">
            {productName}
            {hasArtNo && <div className="text-neutral-80">{t('common:art_no', { artNo: invoiceItem.SKU })}</div>}
          </div>
        )
      }
    >
      <div ref={nameRef} className="w-full truncate">
        {productName}
        {hasArtNo && <div className="truncate text-neutral-40 body-4">{t('common:art_no', { artNo: invoiceItem.SKU })}</div>}
      </div>
    </Tooltip>
  );
};
